/**
 * Copyright (C) 2025 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import appTheme from '../components/common/theme/appTheme.json';

// Enum for GPS Position Accuracy Levels
export enum GpsPositionAccuracyLevel {
  Normal = 'Normal',
  Reduced = 'Reduced',
  Low = 'Low',
}

// Maximum value for NACp (Navigation Accuracy Category-Position)
export const NACP_MAX_VALUE = 11;

// Thresholds for the different GPS accuracy levels (note the higher the NACp value, the higher the accuracy)
export const NACP_NORMAL_ACCURACY_THRESHOLD = 8;
export const NACP_REDUCED_ACCURACY_THRESHOLD = 4;
export const NACP_LOW_ACCURACY_THRESHOLD = 0;

// Determine the accuracy level for a given NACp mode value based on the provided thresholds
// Note: The higher the NACp value, the higher the accuracy
export function getGpsPositionAccuracyLevel(nacPMode: number): GpsPositionAccuracyLevel {
  if (nacPMode >= NACP_NORMAL_ACCURACY_THRESHOLD) {
    return GpsPositionAccuracyLevel.Normal;
  } else if (nacPMode >= NACP_REDUCED_ACCURACY_THRESHOLD) {
    return GpsPositionAccuracyLevel.Reduced;
  } else {
    return GpsPositionAccuracyLevel.Low;
  }
}

// Return the correct color that represents a given GPS accuracy level
export function getGpsPositionAccuracyColor(level: GpsPositionAccuracyLevel): string {
  switch (level) {
    case GpsPositionAccuracyLevel.Normal:
      return appTheme.normalAccuracyGreen;
    case GpsPositionAccuracyLevel.Reduced:
      return appTheme.reducedAccuracyYellow;
    case GpsPositionAccuracyLevel.Low:
      return appTheme.lowAccuracyRed;
    default:
      return appTheme.primaryTextColor; // Fallback color if level is not recognized;
  }
}
